import {fbAnalytics} from '@/config/firebaseConfig';

export default new class AnalyticService {

    private uploadEvent = 'upload_image';

    logUploadEvent() {
        if (fbAnalytics && fbAnalytics.logEvent) {
            fbAnalytics.logEvent(this.uploadEvent);
        }
    }
}
